export const config = {
    stripe: {
        key: process.env.REACT_APP_STRIPE_PUBLIC_KEY ?? "",
    },
    payment: {
        kiwify_checkout_url: process.env.REACT_APP_KIWIFY_PAYMENT_URL ?? "",
        kiwify_lower_price_checkout_url: process.env.REACT_APP_KIWIFY_LOWER_PRICE ?? "",
    },
    google: {
        client_id: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT ?? "",
        redirect_uri: process.env.REACT_APP_GOOGLE_REDIRECT_URL ?? "",
    },
    api: {
        url: process.env.REACT_APP_API_URL ?? ""
    }
}